<script>
import axios from 'axios';
import { $vfm } from 'vue-final-modal';

export default {
  props: ['roster', 'mobile'],
  methods: {
    share() {
      const url = '/rosters/' + this.roster.id + '/share.json';

      axios.get(url)
        .then(response => {
          const code = response.data.code;
          navigator.clipboard.writeText(code);

          $vfm.show({
            component: 'Modal',
            bind: {
              name: 'Modal',
              showClose: false,
            },
            slots: {
              title: {
                component: 'VTitle',
                bind: {
                  text: ''
                }
              },
              default: {
                component: 'VContent',
                bind: {
                  code: code,
                },
              },
            },
            on: {
              confirm(close) {
                close();
              },
              cancel(close) {
                close();
              },
            }
          });
        }
      );
    }
  }
}
</script>

<template>
  <template v-if="mobile">
    <button :disabled="!roster.id" class="mobile-share" type="button" @click.stop.prepend="share">
      <img src="@/images/img/mobile_share.png">
    </button>
  </template>

  <template v-else>
    <button :disabled="!roster.id" class="header-action button button_plain button_icon" @click.stop.prepend="share">
      <img src="@/images/img/share.png" alt="">
    </button>
  </template>
</template>
